import request from "./request"

// const path = 'dj.api.'
const path2 = "dj.api.smartcarlife."

export function getTodayInvite(data) {
  data.method = `${path2}workbench.todayToInvite.count`
  return request(data)
}

export function getTotalData(data) {
  data.method = `${path2}workbench.statistics.total`
  return request(data)
}

export function getCustomerData(data) {
  data.method = `${path2}workbench.statistics.customer`
  return request(data)
}

export function getTransferData(data) {
  data.method = `${path2}workbench.statistics.customer.transfer`
  return request(data)
}

export function getCustomerTransList(data) {
  data.method = `${path2}workbench.statistics.customer.listCountByDay`
  return request(data)
}

export function getStoreFlow(data) {
  data.method = `${path2}workbench.statistics.serviceMerchantToShop.radioRankList`
  return request(data)
}

export function getOrderProductData(data) {
  data.method = `${path2}workbench.statistics.goods.countRankByDay`
  return request(data)
}

export function getIncomeFlowList(data) {
  data.method = `${path2}workbench.statistics.income.listCountByMonth`
  return request(data)
}

export function getIncomeProductList(data) {
  data.method = `${path2}workbench.statistics.goods.grossProfitRadio`
  return request(data)
}

// 获取平台方列表
export function getPlatformMerchantList(data) {
  data.method = `${path2}serviceMerchant.platformMerchant.list`
  return request(data, "post")
}

export function getExportDailyReport(data) {
  data.method = `${path2}workbench.exportDailyReport`
  return request(data)
}

export function getMerchantOutputValueTarget(data) {
  data.method = `${path2}workbench.listMerchantOutputValueTarget`
  return request(data)
}

export function setMerchantOutputValueTarget(data) {
  data.method = `${path2}workbench.inputMerchantOutputValueTarget`
  return request(data, "post")
  // return request(data)
}

// 单店信息模板导出
export function merchantOutputValueTargetExport(data) {
  data.method = `${path2}workbench.merchantOutputValueTargetExport`
  return request(data, "post")
  // return request(data)
}
// 单店信息模板填写后导入
export function merchantOutputValueTargetImport(data) {
  data.method = `${path2}workbench.merchantOutputValueTargetImport`
  // return request(data, "post")
  return request(data, "post", ["file"])
  // return request(data)
}

// 单店信息督导和员工查询
export function findMerchantStaffList(data) {
  data.method = `${path2}workbench.findMerchantStaffList`
  // return request(data, "post")
  return request(data)
}
export function merchantStaffByRoleList(data) {
  data.method = `${path2}merchant.staff.by.role.list`
  return request(data)
}

// 隐私协议标题查询
export function getPrivacyAgreement(data) {
  data.method = `${path2}privacyAgreement.getTitleByModule`
  return request(data, "post")
}

// 新增或更新隐私协议
export function insertOrUpdatePrivacyAgreement(data) {
  data.method = `${path2}privacyAgreement.insertOrUpdate`
  return request(data, "post")
}
